import { Modal, Form, Input } from 'antd';
import { useTranslation, Trans } from 'react-i18next';
import { replaceSku } from '@redux/orders/actions';
import { useDispatch } from '@redux';
import { useState } from 'react';

const ReplaceModal = ({ oldVariantSku, onCancel, href, id }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleSubmit = (values) => {
    setLoading(true);
    dispatch(
      replaceSku({
        data: {
          data: {
            ...values,
            line: oldVariantSku.item?.itemIndex,
            subLine: oldVariantSku?.item?.comboIndex,
          },
          id,
        },
      }),
    ).then((res) => {
      setLoading(false);
      if (res?.payload?.success) window.location.reload();
    });
  };

  return (
    <Modal
      open={!!oldVariantSku}
      title={t('orderDetail.replaceSKU')}
      onCancel={onCancel}
      onOk={form.submit}
      okButtonProps={{ loading: loading }}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Trans
          i18nKey="orderDetail.replaceSKUDesc"
          components={{
            a: (
              <a
                className="underline text-[--primary]"
                href={href}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
        <br />
        <br />
        <Form.Item
          name="variantSku"
          rules={[
            { required: true, message: t('input.variantSku.input.require') },
          ]}
        >
          <Input placeholder={t('input.variantSku.input.placeholder')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReplaceModal;
